import React from 'react';
import { BadgeCheckIcon, ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-[#0A0A0A] px-5 py-20" data-id="element-81" data-mp="4ui1x7m5v3jp">
      <div className="mx-auto max-w-3xl border-t-8 border-[#d4af37] bg-white p-8 text-center shadow-2xl sm:p-14" data-id="element-82" data-mp="4xcmcz56cod4">
        <p className="inline-flex items-center gap-2 bg-[#d4af37] px-4 py-2 text-xs font-bold uppercase tracking-widest" data-id="element-83" data-mp="etfxuvlx1zcq">
          <BadgeCheckIcon className="h-4 w-4" data-id="element-84" data-mp="jt276tymivg9" />
          Zero risk
        </p>
        <ShieldCheckIcon className="mx-auto mt-7 h-20 w-20 text-[#b18b18]" strokeWidth={1.4} data-id="element-85" data-mp="nu47zf86vfkc" />
        <h2 className="mt-6 font-display text-5xl font-bold uppercase leading-none sm:text-6xl" data-id="element-86" data-mp="skuewww9jqh5">
          7-day <span className="text-[#b18b18]" data-id="element-87" data-mp="xjnv4x2xpvl0">guarantee</span>
        </h2>
        <p className="mx-auto mt-6 max-w-lg text-lg font-medium text-[#5A5A66]" data-id="element-88" data-mp="xm1ngy68ctov">
          Open everything. Check every session. Apply the drills.
        </p>
        <p className="mt-5 text-2xl font-bold leading-tight text-[#0A0A0A]" data-id="element-89" data-mp="17j6dxa73zbbh">
          Try Rugby Ready risk-free. If you’re not fully satisfied,{' '}
          <span className="text-[#b18b18]" data-id="element-90" data-mp="25pkjpp1mvhbw">
            we’ll refund you 100% — no questions asked.
          </span>
        </p>
        <p className="mt-6 inline-block border border-[#d4af37]/50 bg-[#d4af37]/10 px-4 py-2 text-xs font-bold uppercase tracking-widest text-[#9b7914]" data-id="element-91" data-mp="1vt7ounucqxfk">
          Refund rate below 1%
        </p>
      </div>
    </section>;
}